//@flow
import { call, put, all, takeLatest } from "redux-saga/effects";
import { Platform, Vibration } from "react-native";
import { showAlert } from "../profileSettings/actions";

import {
  USER_MODIFY_PICTURE,
  USER_MODIFY_NAME,
  USER_REQUESTING,
  USER_MODIFY_REQUESTING,
  USER_MODIFY_ERROR,
  USER_ADD_DEVICE_ID,
  USER_SEND_PULSE_NOTIFICATION_REQUESTING,
  USER_SEND_PULSE_NOTIFICATION_SUCCESS,
  USER_SEND_PULSE_NOTIFICATION_ERROR,
  USER_GET_COMPANY_LOGO_REQUESTING,
  USER_GET_COMPANY_LOGO_SUCCESS,
  USER_GET_COMPANY_LOGO_ERROR,
  UPDATE_USER_WITHOUT_RESPONSE_ERROR,
  UPDATE_USER_WITHOUT_RESPONSE_SUCCESS,
  UPDATE_USER_WITHOUT_RESPONSE_REQUESTING,
  MY_USERS_DELETE_SUCCESS,
  MY_USERS_DELETE_ERROR,
  MY_USERS_DELETE_REQUESTING,
} from "./constants";

import { modifyUser, setUser } from "./actions";

import { fetchApi } from "../api";
import getDeviceId from "./getDeviceId";
import { LOGOUT } from "../login/constants";
import i18n from "../../i18n";

const endPoints = {
  getProfile: "/v1/users/profile",
  getUserById: "/v1/users/",
  modifyUser: "/v1/users/",
  deleteUser: "/v1/users/", // userId
  addFriend: "/v1/users/friends/create",
  sendPulseNotification: "/v1/users/send-pulse-notification",
  getCompanyLogo: "/v1/clients/logo/",
  updateUserWithoutResponse: "/v1/users/update-without-response/",
};

type modifyUserType = {
  fullName?: string;
  firstName?: string;
  LastName?: string;
  picture?: string;
  title?: string;
  experience?: number;
  level?: number;
  email?: string;
};

type addFriendType = {
  userId: string;
  friendId: string;
};

const updateUserWithoutResponseApi = payload => {
  return fetchApi(endPoints.updateUserWithoutResponse, payload, "post");
};

const getUserApi = (data: string) => {
  return fetchApi(endPoints.getUserById + data, {}, "get");
};

const deleteUserApi = data => {
  const { userId } = data;
  return fetchApi(`${endPoints.deleteUser}/${userId}`, data, "delete");
};

const getCompanyLogoApi = data => {
  const { clientId } = data;
  return fetchApi(endPoints.getCompanyLogo + clientId, {}, "get");
};

export const modifyUserApi = (userId: string, userData: modifyUserType) => {
  return fetchApi(endPoints.modifyUser + userId, userData, "patch");
};

export const sendPulseNotificationApi = (data: {
  userId: string;
  friendId: string;
}) => {
  return fetchApi(endPoints.sendPulseNotification, data, "post");
};

function* sendPulseNotificationFlow(action) {
  try {
    Vibration.vibrate(400);

    yield call(sendPulseNotificationApi, action.payload);
    yield put(
      showAlert({
        title: i18n.t("send-pulse-success-title"),
        message: i18n.t("send-pulse-success-message"),
      }),
    );
    yield put({ type: USER_SEND_PULSE_NOTIFICATION_SUCCESS });
  } catch (error) {
    console.log(error);
    yield put({ type: USER_SEND_PULSE_NOTIFICATION_ERROR });
  }
}

function* updateUserWithoutResponseFlow(action) {
  try {
    const { payload } = action;
    const response = yield call(updateUserWithoutResponseApi, payload);
    yield put({ type: UPDATE_USER_WITHOUT_RESPONSE_SUCCESS, payload });
  } catch (error) {
    console.log(error);
    yield put({ type: UPDATE_USER_WITHOUT_RESPONSE_ERROR, payload: error });
  }
}

function* modifyUserFlow(action) {
  try {
    const { id, payload } = action;
    const response = yield call(modifyUserApi, id, payload);
    yield put(modifyUser(response));
  } catch (error) {
    console.log(error);
    yield put({ type: USER_MODIFY_ERROR, payload: error });
  }
}

function* addDeviceIdFlow(action) {
  if (Platform.OS !== "web") {
    const deviceId = yield getDeviceId();
    if (deviceId) {
      const { userId } = action.payload;
      yield call(modifyUserFlow, { id: userId, payload: { deviceId } });
      // user has a device token
    } else {
      console.log("ELSSSE");
      // user doesn't have a device token yet
    }
  }
}

export function* getUserFlow(action) {
  try {
    const data = action.payload;
    const response = yield call(getUserApi, data);
    yield put(setUser(response));
  } catch (error) {
    console.log(error);
    // yield put({ type: SIGNUP_ERROR, error })
  }
}

function* deleteMyUserFlow(action) {
  try {
    const result = yield call(deleteUserApi, action.payload);
    yield put({ type: MY_USERS_DELETE_SUCCESS, payload: result });
    yield put({ type: LOGOUT, payload: action.payload });
  } catch (error) {
    console.log(error);
    yield put({ type: MY_USERS_DELETE_ERROR, payload: error });
  }
}

function* getCompanyLogoFlow(action) {
  try {
    const response = yield call(getCompanyLogoApi, action.payload);
    yield put({ type: USER_GET_COMPANY_LOGO_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: USER_GET_COMPANY_LOGO_ERROR, payload: error });
  }
}

// Watches for the SIGNUP_REQUESTING action type
// When it gets it, it will call signupFlow()
// WITH the action we dispatched
function* userWatcher() {
  yield all([
    takeLatest(USER_REQUESTING, getUserFlow),
    // takeEvery(ONBOARDING_END, setOnboardingPictureFlow),
    takeLatest(
      [USER_MODIFY_REQUESTING, USER_MODIFY_NAME, USER_MODIFY_PICTURE],
      modifyUserFlow,
    ),
    takeLatest(MY_USERS_DELETE_REQUESTING, deleteMyUserFlow),
    takeLatest(USER_ADD_DEVICE_ID, addDeviceIdFlow),
    takeLatest(
      USER_SEND_PULSE_NOTIFICATION_REQUESTING,
      sendPulseNotificationFlow,
    ),
    takeLatest(USER_GET_COMPANY_LOGO_REQUESTING, getCompanyLogoFlow),
    takeLatest(
      UPDATE_USER_WITHOUT_RESPONSE_REQUESTING,
      updateUserWithoutResponseFlow,
    ),
  ]);
}

export default userWatcher;
